<template>
  <div class="card">
    <div class="card-header text-center d-flex" :style="{
      backgroundColor:
        this.about_banner.approval === 'Pending' ? '#ffc107' : 'black',
      padding: '10px',
      color: 'white',
    }">
      <h5 class="flex-grow-1">Banner</h5>
      <span v-if="this.about_banner.approval === 'Pending'" class="float-right btn bg-secondary"><i
          class="fa fa-lock text-white"></i></span>
    </div>
    <div class="card-body">
      <div class="col-4">
        <div style="display: flex; flex-direction: column">
          <div style="display: flex; flex-direction: row; align-items: center">
            <img :src="about_banner.image_url" style="
                width: 120px;
                height: 120px;
                object-fit: contain;
                border-radius: 10px;
                border: dashed 1px gray;
              " />
            <div v-if="!isApprover && this.about_banner.approval !== 'Pending'"
              class="fileUpload bg-none text-left align-middle d-block">
              <div>
                <span class="media-text p-2">Select from Media Library (Max dimension 1200 x 800 px)</span>
              </div>
              <button @click="openGalleryModal('banner_about_us')" aria-hidden="true" class="mx-2 p-2 border w-auto">
                Browse...
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="float-right">
        <button @click="bannerButtonPreview()" class="btn btn-light m-2">
          Preview
        </button>
        <button v-if="!isApprover && about_banner.approval !== 'Pending'" @click="aboutBannerDraft"
          class="btn btn-light m-2">
          Save Draft
        </button>
        <button v-if="!isApprover && about_banner.approval !== 'Pending'" @click="aboutBannerSubmit"
          class="btn btn-warning m-2">
          Submit For Approval
        </button>
        <button v-if="isApprover && about_banner.approval === 'Pending'" data-bs-toggle="modal"
          data-bs-target="#approveModal" class="btn btn-warning m-2 approveModal"
          @click="openApprovalModal('aboutus_banner')">
          Approval
        </button>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header text-center d-flex" :style="{
      backgroundColor:
        this.about_image.approval === 'Pending' ? '#ffc107' : 'black',
      padding: '10px',
      color: 'white',
    }">
      <h5 class="flex-grow-1">About Us Image</h5>
      <span v-if="this.about_image.approval === 'Pending'" class="float-right btn bg-secondary"><i
          class="fa fa-lock text-white"></i></span>
    </div>
    <div class="card-body">
      <div class="col-4">
        <div style="display: flex; flex-direction: column">
          <div style="display: flex; flex-direction: row; align-items: center">
            <img :src="about_image.image_url" style="
                width: 120px;
                height: 120px;
                object-fit: contain;
                border-radius: 10px;
                border: dashed 1px gray;
              " />
            <div v-if="!isApprover && this.about_image.approval !== 'Pending'"
              class="fileUpload bg-none text-left align-middle d-block">
              <div>
                <span class="media-text p-2">Select from Media Library (Max dimension 1200 x 800 px)</span>
              </div>
              <button @click="openGalleryModal('aboutus_image')" aria-hidden="true" class="mx-2 p-2 border w-auto">
                Browse...
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="float-right">
        <button @click="aboutImagePreview()" class="btn btn-light m-2">
          Preview
        </button>
        <button v-if="!isApprover && about_image.approval !== 'Pending'" @click="aboutImageDraft"
          class="btn btn-light m-2">
          Save Draft
        </button>
        <button v-if="!isApprover && about_image.approval !== 'Pending'" @click="aboutImageSubmit"
          class="btn btn-warning m-2">
          Submit For Approval
        </button>
        <button v-if="isApprover && about_image.approval === 'Pending'" data-bs-toggle="modal"
          data-bs-target="#approveModal" class="btn btn-warning m-2 approveModal"
          @click="openApprovalModal('aboutus_image')">
          Approval
        </button>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header text-center d-flex" :style="{
      backgroundColor:
        this.about_description.approval === 'Pending' ? '#ffc107' : 'black',
      padding: '10px',
      color: 'white',
    }">
      <h5 class="flex-grow-1">About Us</h5>
      <span v-if="this.about_description.approval === 'Pending'" class="float-right btn bg-secondary"><i
          class="fa fa-lock text-white"></i></span>
    </div>
    <div class="card-body">
      <ckeditor :editor="editor" v-model="about_description.description" :config="editorConfig"
        :disabled="isApprover || about_description.approval === 'Pending'">
      </ckeditor>

      <div class="float-right">
        <button @click="aboutUsPreview()" class="btn btn-light m-2">
          Preview
        </button>
        <button v-if="!isApprover && about_description.approval !== 'Pending'" @click="aboutUsDraft"
          class="btn btn-light m-2">
          Save Draft
        </button>
        <button v-if="!isApprover && about_description.approval !== 'Pending'" @click="aboutUsSubmit"
          class="btn btn-warning m-2">
          Submit For Approval
        </button>
        <button v-if="isApprover && about_description.approval === 'Pending'" data-bs-toggle="modal"
          data-bs-target="#approveModal" class="btn btn-warning m-2 approveModal"
          @click="openApprovalModal('about_description')">
          Approval
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SmallButtonComponent from "@/components/SmallButtonComponent.vue";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { getRequest, postRequest } from "@/services/RequestService";
import ImageComponent from "@/components/ImageComponent.vue";
import ApprovalComponent from "@/components/ApprovalComponent.vue";
import { checkUserRole } from "@/services/Auth.js";

export default {
  components: {
    SmallButtonComponent,
    ckeditor: CKEditor.component,
    ImageComponent,
    ApprovalComponent,
  },

  data() {
    return {
      about_banner: [],
      about_image: [],
      about_description: [],
      isApprover: false,
      datas: [],
      modalVisible: false,

      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "|",
          "link",
          "blockQuote",
          "|",
          "bulletedList",
          "numberedList",
          "outdent",
          "indent",
          "undo",
          "redo",
        ],
        height: "100",
        line: "50",
      },
    };
  },

  methods: {
    async loadAboutUs() {
      try {
        let response = await getRequest("/about-us/create?section=2", true);

        if (response.data.success === false) {
          throw new Error("Error encountered. Please try again.");
        }

        this.about_banner = response.data.data.about_banner;
        this.about_image = response.data.data.about_image;
        this.about_description = response.data.data.about_description;
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    },

    openGalleryModal(section) {
      console.log("Open Gallery for:", section);

      document.getElementById("modal_id").value = section;

      var galleryModal = document.getElementById("galleryModal");
      galleryModal.classList.add("show");
      galleryModal.style.display = "block";

      this.$emit("about_banner", {
        banner: this.about_banner,
        image: this.about_image,
      });
    },

    //Banner Section
    async bannerButtonPreview() {
      if (this.about_banner.approval == 'Pending' || (this.about_banner.approval == 'Approved' && this.isApprover)) {
        window.open("/about-us?preview=1");
      } else {
        let postData = {
          image: this.about_banner.gallery_id
            ? this.about_banner.gallery_id
            : this.about_banner.image_id,
          approval: false,
        };

        let response;
        if (this.about_banner.approval === "Draft") {
          response = await postRequest(
            "/about-us/banner/" + this.about_banner.id,
            postData
          );
        } else {
          response = await postRequest("/about-us/banner", postData);
        }

        if (response.data.success) {
          window.open("/about-us?preview=1", "_blank");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },
    aboutBannerDraft() {
      this.bannerSubmission(this.about_banner, 0);
    },
    aboutBannerSubmit() {
      this.bannerSubmission(this.about_banner, 1);
    },

    async bannerSubmission(data, approval) {
      try {
        let post_request = this._bannerRequest(data);
        post_request.approval = approval;

        let response;
        if (this.about_banner.approval === "Draft") {
          response = await postRequest(
            "/about-us/banner/" + this.about_banner.id,
            post_request
          );
        } else {
          response = await postRequest("/about-us/banner", post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _bannerRequest(data) {
      return {
        image: this.about_banner.gallery_id
          ? this.about_banner.gallery_id
          : this.about_banner.image_id,
        status: 0,
      };
    },

    //About Us Image Section
    async aboutImagePreview() {
      if (this.about_image.approval == 'Pending' || (this.steabout_imageps.approval == 'Approved' && this.isApprover)) {
        window.open("/about-us?preview=1");
      } else {
        let postData = {
          image: this.about_image.gallery_id
            ? this.about_image.gallery_id
            : this.about_image.image_id,
          approval: false,
        };

        let response;
        if (this.about_image.approval === "Draft") {
          response = await postRequest(
            "/about-us/image/" + this.about_image.id,
            postData
          );
        } else {
          response = await postRequest("/about-us/image", postData);
        }

        if (response.data.success) {
          window.open("/about-us?preview=1", "_blank");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },
    aboutImageDraft() {
      this.imageSubmission(this.about_image, 0);
    },
    aboutImageSubmit() {
      this.imageSubmission(this.about_image, 1);
    },

    async imageSubmission(data, approval) {
      try {
        let post_request = this._imageRequest(data);
        post_request.approval = approval;

        let response;
        if (this.about_image.approval === "Draft") {
          response = await postRequest(
            "/about-us/image/" + this.about_image.id,
            post_request
          );
        } else {
          response = await postRequest("/about-us/image", post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _imageRequest(data) {
      return {
        image: this.about_image.gallery_id
          ? this.about_image.gallery_id
          : this.about_image.image_id,
        status: 0,
      };
    },

    //About Us Description Section
    async aboutUsPreview() {
      if (this.about_description.approval == 'Pending' || (this.about_description.approval == 'Approved' && this.isApprover)) {
        window.open("/about-us?preview=1");
      } else {
        let postData = {
          description: this.about_description.description,
          approval: false,
        };

        let response;
        if (this.about_description.approval === "Draft") {
          response = await postRequest(
            `/about-us/description/` + this.about_description.id,
            postData
          );
        } else {
          response = await postRequest(`/about-us/description`, postData);
        }

        if (response.data.success) {
          window.open("/about-us?preview=1", "_blank");
          location.reload();
        }
        else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },
    aboutUsDraft() {
      this.descriptionSubmission(this.about_description, 0);
    },
    aboutUsSubmit() {
      this.descriptionSubmission(this.about_description, 1);
    },

    async descriptionSubmission(data, approval) {
      try {
        let post_request = this._desriptionRequest(data);
        post_request.approval = approval;

        if (data === null) {
          this.$swal({
            icon: "error",
            text: "Please Fill in Description",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        let response;
        if (this.about_description.approval === "Draft") {
          response = await postRequest(
            `/about-us/description/` + this.about_description.id,
            post_request
          );
        } else {
          response = await postRequest(`/about-us/description`, post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _desriptionRequest(data) {
      return {
        description: data.description,
        status: 0,
      };
    },

    async checkUserRole() {
      this.isApprover = await checkUserRole();
    },

    openApprovalModal(modalName) {
      document.getElementById("data_id").value = modalName;

      this.$emit("about_approval", {
        banner: this.about_banner,
        image: this.about_image,
        description: this.about_description,
      });

    },
  },

  async mounted() {
    this.checkUserRole();
    await this.loadAboutUs();
    console.log(this.about_banner);
  },
};
</script>

<style></style>
